"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.89 4.78v6.43c0 .56-.46 1.02-1.02 1.02l.02-7.45-.02-.02H1.12l-.02 6.45 12.77.02v1H1.12c-.56 0-1.02-.46-1.02-1.02V4.78c0-.56.46-1.02 1.02-1.02h13.75c.56 0 1.02.46 1.02 1.02Zm-3.1 3.77-1.6-2.82H10.1v4.53h1.09V7.44l1.61 2.82h1.09V5.73H12.8v2.82h-.01ZM3.05 5.73H1.84l1.51 4.53h1.2l1.52-4.53H4.85l-.9 3.3-.9-3.3Zm5.42 4.54V5.74H7.38v4.53h1.09Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.14 12.825V8.618h1.627v6.757h-1.62l-2.392-4.207v4.207h-1.627V8.617h1.627l2.393 4.208h-.008Zm3.142-6.892H1.71C.885 5.933.217 6.6.217 7.425v9.15c0 .825.668 1.492 1.493 1.492h19.815v-1.125H1.71a.368.368 0 0 1-.368-.367v-9.15c0-.203.165-.367.368-.367h20.573c.202 0 .367.164.367.367v10.59a1.488 1.488 0 0 0 1.125-1.44v-9.15a1.49 1.49 0 0 0-1.492-1.492Zm-9.577 9.442V8.617h-1.627v6.758h1.627ZM4.62 8.617H2.812l2.258 6.758h1.785l2.272-6.758H7.305l-1.35 4.92-1.343-4.92h.008Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.52 17.1v-5.61h2.17v9.01h-2.16l-3.19-5.61v5.61h-2.17v-9.01h2.17l3.19 5.61h-.01Zm4.19-9.19H2.28C1.18 7.91.29 8.8.29 9.9v12.2c0 1.1.89 1.99 1.99 1.99H28.7v-1.5H2.28a.49.49 0 0 1-.49-.49V9.9c0-.27.22-.49.49-.49h27.43c.27 0 .49.22.49.49v14.12c.86-.22 1.5-.99 1.5-1.92V9.9c0-1.1-.89-1.99-1.99-1.99ZM16.94 20.5v-9.01h-2.17v9.01h2.17ZM6.16 11.49H3.75l3.01 9.01h2.38l3.03-9.01H9.74l-1.8 6.56-1.79-6.56h.01Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.565 14.842v18.315c0 1.253-.78 2.326-1.875 2.76V14.842c0-.607-.495-1.102-1.102-1.102H3.42c-.608 0-1.103.495-1.103 1.102v18.315c0 .608.495 1.103 1.103 1.103h40.395v1.875H3.42a2.98 2.98 0 0 1-2.978-2.977V14.841a2.98 2.98 0 0 1 2.978-2.977h41.167a2.98 2.98 0 0 1 2.978 2.977Zm-14.055 2.4h-3.262v13.523h3.262V22.35l4.793 8.415h3.24V17.242h-3.248v8.415l-4.785-8.415Zm-24.27 0H5.625l4.515 13.523h3.57l4.552-13.523h-3.645l-2.692 9.848-2.685-9.848Zm16.17 13.523V17.242h-3.247v13.523h3.247Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.42 19.79v24.42c0 1.67-1.04 3.1-2.5 3.68v-28.1c0-.81-.66-1.47-1.47-1.47H4.56c-.81 0-1.47.66-1.47 1.47v24.42c0 .81.66 1.47 1.47 1.47h53.86v2.5H4.56c-2.19 0-3.97-1.78-3.97-3.97V19.79c0-2.19 1.78-3.97 3.97-3.97h54.89c2.19 0 3.97 1.78 3.97 3.97Zm-18.74 3.2h-4.35v18.03h4.35V29.8l6.39 11.22h4.32V22.99h-4.33v11.22l-6.38-11.22Zm-32.36 0H7.5l6.02 18.03h4.76l6.07-18.03h-4.86L15.9 36.12l-3.58-13.13Zm21.56 18.03V22.99h-4.33v18.03h4.33Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconVINNumber = function IconVINNumber(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'VIN Number' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "VINNumber"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconVINNumber.sizes = [16, 24, 32, 48, 64];
IconVINNumber.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconVINNumber;
exports.default = _default;